import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Skeleton from '@mui/material/Skeleton';
import Slide from '@mui/material/Slide';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import OrderListTable from './OrderListTable'
import PickupRequestDetail from './PickupRequestDetail'
import OrderMapView from './OrderMapView';


function OpenOrders(props) {
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [orders, setOrders] = React.useState([]);
    const [selectedOrder, setSelectedOrder] = React.useState(null);
    React.useEffect(() => {
        loadOrders(); // only called once
    }, []);

    function loadOrders() {
        setIsFetching(true);
        var postData = {
            version: '2.0'
        }
        TokenService.post(postData, 'Get_MyOrders')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let tempOrders = jsonData.Orders;

                    if (tempOrders != '') {
                        tempOrders = JSON.parse(tempOrders);
                    }

                    let userLevel = jsonData.ReturnerLevel;
                    if (userLevel != '') {
                        userLevel = JSON.parse(userLevel);
                    }
                    props.userLevelUpdated(userLevel);

                    setOrders(tempOrders);
                   
                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function buildOrders() {
        if (orders.length == 0) {
            return <div>You do not have any Open Orders</div>
        }
        else {
            return <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Open' OrderSelected={handleOrderSelected} userLevelUpdated={props.userLevelUpdated} />
        }
    }

    function buildMap() {
        if (orders.length == 0) {
            return null;
        }
        else {
            return (
            <Card style={{ display: (selectedOrder == null ? 'block' : 'none') }} sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px', marginTop: '10px' }}>
                    <CardContent style={{ padding: '5px' }}>
                        <div style={{fontSize:'10pt'} }>Map pins are approximate locations</div>
                    <OrderMapView Orders={orders} loggedInUser={props.loggedInUser} Section='Open' OrderSelected={handleOrderSelected} />
                </CardContent>
            </Card>)
        }
    }

    function handleCloseDetail() {
        setSelectedOrder(null);
    }

    function handleOrderSelected(order) {
        setSelectedOrder(order);
    }

    function handleRequestRescheduled(pickupRequest, selectedDate, selectedTime) {
        //alert('handleRequestUnscheduled: ' + pickupRequest.RequestID);
        setIsFetching(true);
        let postData = {
            OrderGUID: pickupRequest.OrderGUID,
            ReturnerPickUpDate: selectedDate,
            ReturnerPickUpWindow: selectedTime
        }
        TokenService.post(postData, 'UpdateOrder')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    enqueueSnackbar("You have rescheduled this pickup", {
                        variant: 'success',
                    });
                    if (response.JsonData != '') {
                        setSelectedOrder(JSON.parse(response.JsonData));
                    }
                    //props.orderMoved('OpenOrders', 'AvailableOrders');
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }
                loadOrders();
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });

       

    }

    function handleRequestUnscheduled(pickupRequest, reason) {
        //CancelPickUp(string OrderGUID, string reason)
        let postData = {
            OrderGUID: pickupRequest.OrderGUID,
            reason: reason
        }
        TokenService.post(postData, 'CancelPickUp')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    loadOrders();
                }
                 props.orderMoved('OpenOrders', 'AvailableOrders');
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });

        window.setTimeout(function () {
            setSelectedOrder(null); // add a little delay to so the slide animation looks more natural
        }, 400);
    }

    function handleRequestDeclined(pickupRequest) {
        let postData = {
            OrderGUID: pickupRequest.OrderGUID
        }
        TokenService.post(postData, 'DeclinePickUp')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    loadOrders();
                }
                props.orderMoved('OpenOrders', 'AvailableOrders');
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });

        window.setTimeout(function () {
            setSelectedOrder(null); // add a little delay to so the slide animation looks more natural
        }, 400);
    }

    function handlePaymentCompleted(pickupRequest, paypalDetails) {
        let finalizePaymentPostData = {
            orderGUID: pickupRequest.OrderGUID,
            paymentId: paypalDetails.purchase_units[0].payments.captures[0].id, // the paypal transaction ID visible on the site
            email: paypalDetails.payer.email_address,
            firstName: paypalDetails.payer.name.given_name,
            lastName: paypalDetails.payer.name.surname,
            payerId: paypalDetails.payer.payer_id
        }
        setIsFetching(true);
        TokenService.post(finalizePaymentPostData, 'FinalizePaypalpayment')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    loadOrders();
                    enqueueSnackbar('Payment Completed', {
                        variant: 'success',
                    });
                    props.orderMoved('OpenOrders', 'CompletedOrders');
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });

        window.setTimeout(function () {
            setSelectedOrder(null); // add a little delay to so the slide animation looks more natural
        }, 400);
    }

    return (
        <div componentname='OpenOrders' style={{ display: 'flex', justifyContent: 'center', flexDirection:'column' }}>
            <Card sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px' }}>
                <CardContent style={{ pading: '5px' }} className='OpenOrdersCard'>
                    <Slide direction="right" in={selectedOrder === null} mountOnEnter unmountOnExit >
                        <div>
                        {
                            (props.isFetching || isFetching)
                                ? buildSkeleton() : buildOrders()
                        }
                        </div>
                    </Slide>

                    <Slide direction="left" in={selectedOrder !== null} mountOnEnter unmountOnExit >
                        <div>
                            <PickupRequestDetail
                                PickupRequest={selectedOrder}
                                onBack={() => setSelectedOrder(null)}
                                loggedInUser={props.loggedInUser}
                                onScheduled={handleRequestRescheduled}
                                onUnscheduled={handleRequestUnscheduled}
                                onDeclined={handleRequestDeclined }
                                onPaymentCompleted={handlePaymentCompleted }
                            />
                        </div>
                    </Slide>
                </CardContent>
            
            </Card>
            {
                (props.isFetching || isFetching)
                    ? null :
                    buildMap()
            }
        </div>
    );
}

export default OpenOrders;